import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-two-col-description-list',
  templateUrl: './two-col-description-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoColDescriptionListComponent {}
